// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"ue_a vh_rt vh_cv vh_a","MenuItem__Btn":"ue_b vh_z"};